// extracted by css-extract-rspack-plugin
export default {"root":"iptqQGfkBUVw4wli","lineWrapper":"LcrkqO_s3BkZqI5n","charSlot":"Zy8Pn_lN31cB6VIP","spaceSlot":"mOWa5N1aEz0Tbd0x"};